<div class="wrap">
  <div class="content">
    <div class="sections">
      <div class="section-1">
        <div class="about">
          <div class="title">{{'Stories.about.aboutKetto' | translatePipe | async}}</div>
          <div class="about-img" data-bg="/assets/images/story/faq_sprite_desktop.png"></div>
          <div class="desc">{{'Stories.about.desc' | translatePipe | async}}</div>
          <div class="review-container">
            <div class="review">
              <em class="material-icons">check</em>
              <span>{{'Stories.about.review1' | translatePipe | async}}</span>
            </div>
            <div class="review">
              <em class="material-icons">check</em>
              <span>{{'Stories.about.review2' | translatePipe | async}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2">
        <div class="how-it-works">
          <div class="heading process-txt">Process</div>
          <div class="how-container" *ngFor="let item of howItWorksArray; let i=index;">
            <div *ngIf="!vars.showKCart" class="h-img" [ngStyle]="{'background-position': item.position}" data-bg="/assets/images/story/faq_sprite_desktop.png"></div>
            <div *ngIf="vars.showKCart" class="h-img" [ngStyle]="{'background-position': item.position}" data-bg="/assets/images/faq_sprite_2.png"></div>
            <div class="desc-container">
              <div class="title">{{i+1 + '. '}}{{item.title}}</div>
              <div class="desc">{{item.desc}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

